import * as R from 'ramda'
import { of } from 'rxjs'
import { delayWhen, distinctUntilChanged, filter, ignoreElements, tap } from 'rxjs/operators'
import { ofType } from 'redux-observable'
import { LOCATION_CHANGE } from 'connected-react-router'
import { track } from 'tracking/mixPanel'
import { awaitForSaleFetched } from 'store/epics/helpers'
import { MIXPANEL_ACCESS_MAP } from 'constants/mixpanel'
import { isCatalogOrUniversePageAction } from 'domain/router'
import {
  getDaysSinceStartSale,
  getFilteredProductsLabelsFormattedForTracking,
  getFilteredProductsTagsValues,
  getFilteredViewedProducts,
  getFrom,
  getHasCrossSaleOnLastViewedProducts,
  getHasWithAndWithoutTransportation,
  getIsSaleFetched,
  getIsViewedProductsFetched,
  getNbFilteredProductsWithTags,
  getNbProductsOutOfStock,
  getNormalizedNbSubUniversesInCatalog,
  getNormalizedNbUniversesInCatalog,
  getOperationCode,
  getProductsCountInCatalog,
  getSaleStartTime,
  getSelectedTransportationFromQuery,
  getSubUniverseName,
  getUniverseName
} from 'store/selectors'
import { disableMixPanelTracking } from '../disable'
import { getTransportOptionValue } from './clickTransportationPills'

const getTransportOption = (hasPills, transportation) => {
  if (!hasPills) return

  return { 'Transport option': getTransportOptionValue(transportation) }
}

export const mapStateToMPEvent = (eventName, state) => {
  const nbProductsOutOfStock = getNbProductsOutOfStock(state)
  const hasTransportationPills = getHasWithAndWithoutTransportation(state)
  const selectedTransportation = getSelectedTransportationFromQuery(state)

  return {
    '# of Products Out of Stock': nbProductsOutOfStock,
    '# of References': getProductsCountInCatalog(state),
    '# of Sub Universes': getNormalizedNbSubUniversesInCatalog(state),
    '# of Universes': getNormalizedNbUniversesInCatalog(state),
    'Access': MIXPANEL_ACCESS_MAP[getFrom(state)] || '',
    'Days Since Sale Start': getDaysSinceStartSale(state),
    'Display': 'Small thumbnail',
    'Event Name': eventName,
    ...getFilteredProductsLabelsFormattedForTracking(state),
    'Operation Code': getOperationCode(state),
    'Out of Stock products': (nbProductsOutOfStock > 0),
    'Sale Start Time': getSaleStartTime(state),
    'Stress Marketing Slogan': getFilteredProductsTagsValues(state).join(),
    ...getTransportOption(hasTransportationPills, selectedTransportation),
    'Transportation pills': hasTransportationPills,
    'Under Universe': getSubUniverseName(state),
    'Universe': getUniverseName(state),
    'View Stress Marketing': (getNbFilteredProductsWithTags(state) > 0),
    ...(getIsViewedProductsFetched(state)
      ? {
          '# of Recently Viewed Product Displayed': R.length(getFilteredViewedProducts(state)),
          'Cross Sell Display': getHasCrossSaleOnLastViewedProducts(state),
          'Cross-Sell Type': 'Recently Viewed Product'
        }
      : {}
    )
  }
}

const viewCatalogPageEpic = (actions$, state$) => actions$.pipe(
  disableMixPanelTracking(actions$),
  ofType(LOCATION_CHANGE),
  distinctUntilChanged(R.eqBy(R.path(['payload', 'location', 'pathname']))),
  filter(isCatalogOrUniversePageAction),
  delayWhen(() => getIsSaleFetched(state$.value)
    ? of({})
    : awaitForSaleFetched(actions$, state$)
  ),
  // delayWhen(() => (getIsViewedProductsFetched(state$.value))
  //   ? of({})
  //   : merge(
  //     awaitForLastViewedProductsFetched(actions$, state$),
  //     awaitForPageChanged(actions$)
  //   )
  // ),
  filter(() => getProductsCountInCatalog(state$.value)),
  tap(() => {
    const eventName = 'View Catalogue Page'

    track(eventName, mapStateToMPEvent(eventName, state$.value), { debug: !__PRODUCTION__ })
  }),
  ignoreElements()
)

export default viewCatalogPageEpic
